import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/vercel/path0/src/app/[lang]/[region]/[villas]/Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Catalogs/ScrollArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Trustpilot/TrustBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/VillagesWrapper/index.tsx");
